module.exports = __webpack_public_path__ + "static/media/logo-transparent.33007f54.png";